import { useExperiment } from "../../hooks/experiments";
import {
  CoverTogglesContainer as Control,
  type CoverTogglesContainerProps,
} from "./CoverTogglesContainer";
import { CoverTogglesContainer as Treatment } from "./ExperimentGridView/CoverTogglesContainer";

export * from "./CoverToggle";
export type { CoverTogglesContainerProps } from "./CoverTogglesContainer";

export const CoverTogglesContainer = (props: CoverTogglesContainerProps) => {
  const isTreatment = ["treatment_grid", "treatment_list"].includes(
    useExperiment("uk2505Gridvslistview") || "",
  );

  if (isTreatment) {
    return <Treatment {...props} />;
  }

  return <Control {...props} />;
};
